import { Link, Outlet } from "react-router-dom";
import d1 from "../logo/logo.jpeg";
import { Divider } from "@chakra-ui/react";
import { useState } from "react";

export function Dummy() {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <div>
      <header>
        <nav className="border-gray-200 px-4 lg:px-6 border-b  w-full ">
          <div className="flex flex-row justify-between items-center mx-auto max-w-screen w-full ">
            <div className="logomain flex items-center justify-start max-w-40 md:max-w-48">
              <Link>
                <img
                  src={d1}
                  className="object-cover h-full w-full"
                  alt="Logo"
                />
              </Link>
            </div>

            <div className="flex justify-center items-center  h-full">
              <div className="hidden lg:flex flex-row space-x-16 ">
                <div>
                  <Link to="/" className="text-gray-700 font-medium">
                    Home
                  </Link>
                </div>
                <div>
                  <Link to="/jobs" className="text-gray-700 font-medium">
                    Find Job
                  </Link>
                </div>
                <div>
                  <Link
                    to="/company-list"
                    className="text-gray-700 font-medium"
                  >
                    Companies
                  </Link>
                </div>
              </div>
            </div>

            <div className="lg:hidden flex items-center">
              <button
                onClick={toggleSidebar}
                type="button"
                className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none dark:text-gray-400 dark:hover:bg-gray-700"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>

            <div className="hidden lg:flex flex-row items-center space-x-2">
              <Link
                to="/login"
                className="text-fontBlue border font-semibold hover:bg-gray-50 focus:ring-4 cursor-pointer focus:ring-gray-300 rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 border"
              >
                Log in
              </Link>

              <Link
                to="/signup"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:bg-blue-600 dark:hover:bg-blue-700"
              >
                Signup
              </Link>
            </div>
            {/* Desktop Navigation Links */}
          </div>
        </nav>

        {/* Sidebar for mobile view */}
        {isSidebarOpen && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-75 z-50 flex lg:hidden">
            <div className="w-3/4 max-w-xs bg-white dark:bg-gray-800 h-full p-4 ">
              <button
                onClick={toggleSidebar}
                className="text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 p-2 rounded-lg focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
              <ul className="mt-4 space-y-4">
                <li>
                  <Link
                    to="/"
                    onClick={toggleSidebar}
                    className="block text-gray-900 "
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/jobs"
                    onClick={toggleSidebar}
                    className="block text-gray-900 "
                  >
                    Find Job?
                  </Link>
                </li>
                <li>
                  <Link
                    to="/company-list"
                    onClick={toggleSidebar}
                    className="block text-gray-900 "
                  >
                    Companies
                  </Link>
                </li>
                <li>
                  <div onClick={toggleSidebar} className="block text-gray-900 ">
                    Careers
                  </div>
                </li>
                <Divider />
                <li>
                  <Link
                    to="/login"
                    onClick={toggleSidebar}
                    className="block text-gray-800  hover:bg-gray-50 focus:ring-4 cursor-pointer focus:ring-gray-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 dark:hover:bg-gray-700"
                  >
                    Log in
                  </Link>
                </li>
                <li>
                  <Link
                    to="/signup"
                    onClick={toggleSidebar}
                    className="block text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700"
                  >
                    Signup
                  </Link>
                </li>
              </ul>
            </div>
            <div
              className="w-1/4 h-full cursor-pointer"
              onClick={toggleSidebar}
            ></div>
          </div>
        )}
      </header>
      <Outlet />
    </div>
  );
}
